module.exports = __webpack_public_path__ + "img/GI.a9ebe44c.png";